/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_SecurityInputs */

const en_nav_security = /** @type {(inputs: Nav_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in and security`)
};

/**
* | output |
* | --- |
* | "Sign-in and security" |
*
* @param {Nav_SecurityInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_security = /** @type {((inputs?: Nav_SecurityInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_SecurityInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_security(inputs)
});